/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateEmailMarkAllAsReadPathParams,
	CandidateEmailMarkAllAsReadResponse,
} from '../types/CandidateEmailMarkAllAsRead'

/**
 * POST /candidates/:candidateId/emails/read-all
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::markAllAsRead
 */
export async function candidateEmailMarkAllAsRead(
	candidateId: CandidateEmailMarkAllAsReadPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateEmailMarkAllAsReadResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/emails/read-all`, undefined, config)
}
